/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueDto } from './concernsIssueDto.schema';

export const UpdateConcernsIssue = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => ConcernsIssueDto).optional()
});

export type UpdateConcernsIssue = zod.input<typeof UpdateConcernsIssue>;
export type UpdateConcernsIssueOutput = zod.output<typeof UpdateConcernsIssue>;
